module.exports = __webpack_public_path__ + "img/patient-info-identification-disable.01c4f850.svg";